// extracted by mini-css-extract-plugin
export default {"toggle":"---------packages-corgi-x-src-components-Accordion-legacy-ToggleButton-module__toggle"};